<template>
  <div ref = 'scroll' class = 'scroll-wrap'>
    <div ref = 'scroll_el' class = 'scroll-content'>
      <slot v-bind:list="filterList"></slot>
    </div>
  </div>
</template>

<script>
import { setTimeout } from 'timers';
export default {
  props: {
    list: Array,
    pageSize: Number
  },
  watch: {
    list(val,oldVal){
      // console.log(val,oldVal)
      if((val.length&&val.length!=oldVal.length)||!val.length&&oldVal.length){
        this.current = 0
        this.filterList = []
        this._getFilterList()
      }
    }
  },
  mounted(){
    let scroll = this.$refs['scroll']
    let scroll_el = this.$refs['scroll_el']
    scroll.onscroll = (e)=>{
      // if(scroll.scrollTop)
      if(scroll.scrollHeight - scroll.offsetHeight - scroll.scrollTop <20){
        // console.log('加载')
        this._getFilterList()
      }
    }
    if(this.list&&this.list.length){
      this._getFilterList()
    }
  },
  data(){
    return {
      current: 0,
      filterList: []
    }
  },
  cumputed: {
  },
  methods: {
    _getFilterList(){
      if(this.isLoad){
        return
      }
      let scroll = this.$refs['scroll']
      let scroll_el = this.$refs['scroll_el']
      this.current++
      let arr = this.getArrByCurrent(this.list,this.current)
      // console.log('le',arr)
      if(arr.length){
        this.filterList = this.filterList.concat(arr)
        this.$nextTick(()=>{
          if(scroll.scrollHeight - scroll.offsetHeight - scroll.scrollTop <20){
            // console.log('还需要加载')
            this.isLoad = false
            this._getFilterList()
          }else{
            setTimeout(()=>{
              this.isLoad = false
            },500)
          }
        })
      }else{
        this.isLoad = false
      }
    },
    getArrByCurrent(arr,current){
      let index = (current-1)*this.pageSize
      return arr.slice(index,index+this.pageSize)
    }
  }
}
</script>

<style scoped lang = 'less'>
.scroll-wrap{
  height: 100%;
  overflow-y: auto;
  .scroll-content{
    height: auto;
  }
}
::-webkit-scrollbar-thumb{ 

background-color:#04cbdb; 

height:50px; 

outline-offset:-2px; 

outline:2px solid #fff; 

-webkit-border-radius:4px; 

border: 2px solid #fff; 

}

/*---鼠标点击滚动条显示样式--*/ 

::-webkit-scrollbar-thumb:hover{ 

background-color:#018EE8; 

height:50px; 

-webkit-border-radius:4px; 

}

/*---滚动条大小--*/ 

::-webkit-scrollbar{ 

width:8px; 

height:8px; 

}

/*---滚动框背景样式--*/ 

::-webkit-scrollbar-track-piece{ 

background-color:#fff; 

-webkit-border-radius:0; 

}
</style>